<app-button-menu-item
  name="gallery"
  location="create-gallery-context"
  icon="gallery-plus"
  color="simple"
  [fullWidth]="true"
  (click)="onCreateGallery(['/a', 'gallery', 'create'], { folder: folder ? folder.id : undefined }); onClose.emit()"
  >Create Gallery
</app-button-menu-item>
@if (growthBook.isOn('moodboard')) {
  <app-button-menu-item
    name="gallery"
    location="create-gallery-context"
    icon="gallery-plus"
    color="simple"
    [fullWidth]="true"
    (click)="
      onCreateGallery(['/a', 'gallery', 'create'], { folder: folder ? folder.id : undefined, moodboard: 'true' });
      onClose.emit()
    "
    >Create Moodbaord
  </app-button-menu-item>
}
<app-button-menu-item
  name="folder"
  location="create-gallery-context"
  icon="folder-plus"
  color="simple"
  data-test-id="create-folder"
  (onClick)="createFolder(); onClose.emit()"
  [fullWidth]="true"
  >Create Folder
</app-button-menu-item>
<ng-container>
  <div class="divider"></div>
  <h3 class="menu-list-title">PRESETS</h3>
  @if (loading) {
    <app-loading-indicator size="32"></app-loading-indicator>
  }
  @if (!loading) {
    @for (preset of standardPresets; track preset) {
      <app-button-menu-item
        name="preset"
        location="create-gallery-context"
        icon="toggle"
        color="simple"
        [fullWidth]="true"
        (click)="
          onCreateGallery(['/a', 'gallery', 'create', preset.id], { folder: folder ? folder.id : undefined });
          onClose.emit()
        "
      >
        {{ preset.name || 'Unnamed Preset' }}
      </app-button-menu-item>
    }
    @for (preset of customPresets; track preset) {
      <app-button-menu-item
        name="preset"
        location="create-gallery-context"
        icon="gear-bg"
        appTooltip="{{ preset.name }}"
        color="simple"
        [fullWidth]="true"
        (click)="
          onCreateGallery(['/a', 'gallery', 'create', preset.id], { folder: folder ? folder.id : undefined });
          onClose.emit()
        "
      >
        {{ preset.name || 'Unnamed Preset' }}
      </app-button-menu-item>
    }
    @if (!customPresets.length && !('gallery:custom-presets' | billingScope)) {
      <app-button-menu-item
        name="presets-pro"
        location="create-gallery-context"
        icon="gear-bg"
        color="simple"
        [routerLink]="['/a', 'settings', 'gallery-presets']"
        [fullWidth]="true"
      >
        <span>Custom Presets</span>
        <app-upgrade-badge scope="gallery:custom-presets" location="create-gallery-context"></app-upgrade-badge>
      </app-button-menu-item>
    }
  }
</ng-container>
